import React from 'react';
import {
  withSystem,
  Plugins,
  Atom,
  type AtomRenderProps,
} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {
  isFormCheckboxLabel,
  isFormRadioLabel,
} from '@packages/utilities/elementTypeUtils';
import {TList, TElement, TText, TRecord} from '@packages/systems/wfdl-ast';
import {getChildren} from '@packages/utilities/data-utils';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';

const FormInlineLabel = Atom.createRender(
  ({
    attributes,
    classes,
    generateAttributes,
    innerHTML,
    context,
    data,
    renderChild,
  }: AtomRenderProps) => {
    const inlineLabelClasses = classes.push('w-form-label');
    const attrs = generateAttributes(attributes, inlineLabelClasses);
    const forAttr = context.get('for') || attrs?.for;
    const finalAttrs = {
      ...attrs,
      for: forAttr,
    } as const;
    return (
      <span {...finalAttrs}>
        {/* @ts-expect-error [PDTY-2706] - TS2322 - Type 'RichTextValue | VideoBindingProps | Iterable<number, ReactElement<EvalElementProps, string | JSXElementConstructor<any>>> | null' is not assignable to type 'ReactNode'. */}
        {
          // TODO (platform): fix innerHTML type issues

          innerHTML ||
            getChildren(data).map((child) => renderChild(child, context))
        }
      </span>
    );
  }
);

const config = createDevlinkAtom({
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Text')),
  },
  displayName: {
    type: 'Derived',
    defaultValue: 'Field Label',
    getFromElement: (element) => {
      if (isFormCheckboxLabel(element)) {
        return 'Checkbox Label';
      }

      if (isFormRadioLabel(element)) {
        return 'Radio Button Label';
      }

      return 'Field Label';
    },
  },
  showEmpty: true,
  constraints: {
    pinToParent: true,
  },
  render: FormInlineLabel,
  fields: {
    form: TRecord({
      type: withSystem(
        {
          private: true,
        },
        TText
      ),
    }),
    children: withSystem(
      {
        isBindable: true,
        label: 'Text',
        isLocalizable: true,
      },
      TList(TElement)
    ),
  },
});

export default config;
